<template>
  <div class="game-form-wrap">
    <div v-if="submitted">
      <h2>Nice!</h2>
      <p>Mark has your answers. Just sit tight now.</p>
      <ol>
        <li v-for="(a, p, i) in answers" :key="'a'+i">
          <span>{{a.artist}} - {{a.title}}</span>
          <span v-if="a.notes != ''">({{a.notes}})</span>
        </li>
      </ol>
      <div v-show="status === 'ready'">
        <button class="all" v-on:click="restart">start new round</button>
        <p>Let's go!</p>
      </div>

    </div>
    <div v-else-if="status === 'ready'">
      <h2>Ok, get ready...</h2>
    </div>
    <div v-else>
      <h2>Song {{question}}</h2>
      <form class="game-form" v-on:submit.prevent>
        <input type="text" placeholder="song title" v-model="title" />
        <input type="text" placeholder="artist name" v-model="artist" />
        <input type="text" placeholder="notes (optional)" v-model="notes" />
        <button v-on:click="nextAnswer">save answer</button>
      </form>
      <h3>Answers</h3>
      <div class="answers">
        <div v-for="i in totalQs" :key="'ans'+i" :class="qclasses[i]" v-on:click="setQ(i)">
          <span>{{i}}</span>
        </div>
      </div>

      <div v-show="complete">
        <h3>All answers entered! Review and submit!</h3>
        <span :class="loading ? 'loading' : ''">
          <button class="all" v-on:click="submitAll">submit all answers</button>
        </span>
      </div>
      <div v-if="errors" class="error">
        Uh oh. Something's going on with the server. Your submission wasn't received. You can try pressing the button again.
        <br><br>I'm just an error message, sorry.
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'GameForm',
  data: function() {
    return {
      title: '',
      artist: '',
      notes: '',
      question: 1,
      questionmax: 1,
      totalQs: 8,
      answers: {},
      complete: false,
      submitted: false,
      errors: false,
      loading: false
    }
  },
  props: [ 'name', 'email', 'status' ],
  methods: {
    nextAnswer: function() {
      this.saveAnswer();

      if(this.questionmax == this.totalQs) {
        this.finishedRound();
      }
      
      if(this.question < this.totalQs) {
        if(this.question == this.questionmax) {
          this.questionmax++;
        }
        this.question++;
      }

      this.title = this.artist = this.notes = '';
      var i = this.question;
      if(typeof this.answers[i] !== 'undefined') {
        this.title = this.answers[i].title;
        this.artist = this.answers[i].artist;
        this.notes = this.answers[i].notes;
      }

    },
    saveAnswer: function() {
      var answer = {
        question: this.question,
        title: this.title,
        artist: this.artist,
        notes: this.notes
      }
      this.answers[this.question] = answer;
    },
    setQ: function(i) {
      if(i <= this.questionmax) {
        this.saveAnswer();
        this.question = i;
        this.title = this.answers[i].title;
        this.artist = this.answers[i].artist;
        this.notes = this.answers[i].notes;
      }
    },
    finishedRound: function() {
      this.complete = 'true';
      this.saveAnswer();
    },
    submitAll: function() {
      var a = this.answers;
      this.loading = true;
      axios.post('https://sixstringtrivia.com:3000/', {
        name: this.name, 
        email: this.email,
        answers: a,
        timestamp: new Date().toString()
      })
      .then(() => {
        this.submitted = true;
        this.errors = false;
        this.loading = false;
      })
      .catch(() => {
        this.errors = true;
        this.loading = false;
      });
    },
    restart: function() {
      this.title = '';
      this.artist = '';
      this.notes = '';
      this.question = 1;
      this.questionmax = 1;
      this.totalQs = 8;
      this.answers = {};
      this.complete = false;
      this.submitted = false;
    }
  },
  computed: {
    // a computed getter
    qclasses: function () {
      var c = {1: 'active'};

      for (var i = 1; i <= 8; i++) {
        if(i == this.question) { c[i] = 'active'; }
        else if(i <= this.questionmax) { c[i] = 'done'; }
      }

      return c;
    }
  }
}
</script>

<style lang="scss">
.game-form-wrap {
  display: block;
  input, button {
    display: block;
    width: 100%;
    margin: 20px auto;
    padding: 10px;
    border: solid 1px #000;
    font-size: 1.2em;
  }
  button {
    background: #9a4;
    color: #fff;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    &:hover { background: #771; }
    &.all { background: #941; }
    &.all:hover { 
      background: #420; 
      text-shadow: 0 0 5px #f00;
    }
  }
}
.answers {
  display: flex;
  div {
    width: 12.5%;
    padding: 1px;
    span { 
      display: block; 
      text-align: center;
      color: #fff;
      font-weight: bold;
      padding: 5px 1px;
      border: solid 1px #000;
      background: #aaa;
      pointer-events: none;
    }
    &.done span { background: #9a4; cursor: pointer; }
    &.active span { background: #ffa; color: #000; }
    &.done:hover span, &.active:hover span { background: #771; }
  }
}
.loading {
  button {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
  }
  display: block;
  position: relative;
  &:after {
    position: absolute;
    width: 30px;
    height: 30px;
    border: dotted 5px #565;
    border-radius: 30px;
    top: 50%;
    left: 50%;
    margin-left: -15px;
    margin-top: -15px;
    display: block;
    content: '';
    animation: spin 3s infinite linear
  }
}
@keyframes spin {
    0%  {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
}
</style>
